module.exports = __webpack_public_path__ + "media/battle.b1ef8b94.mp3";